import { PropsWithChildren } from 'react'

import { createStyles } from 'antd-style'

import { FloorCardProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    paddingInline: token.paddingSM
  },
  header: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    flex: 'none',
    paddingBlock: token.paddingXS,
    /* ------------------------------- 跟 tabs 保持一致 ------------------------------ */
    borderBlock: `1px solid transparent`,
    /* ----------------------------------- END ---------------------------------- */
    [`&::before`]: {
      content: '""',
      display: 'inline-block',
      width: 2,
      height: '1em',
      marginRight: token.marginSM,
      backgroundColor: token.colorPrimary
    }
  },
  title: {
    flex: 1,
    fontSize: token.fontSizeHeading5
  },
  body: {
    flex: 1,
    overflow: 'hidden'
  },
  bordered: {
    border: `1px solid ${token.colorBorderSecondary}`
  }
}))

export const FloorCard = ({
  className,
  style,
  styles: externalStyles,
  bordered = true,
  title,
  extra,
  children
}: PropsWithChildren<FloorCardProps>) => {
  const { cx, styles } = useStyles()

  return (
    <div className={cx(styles.container, className)} style={style}>
      <div className={styles.header} style={externalStyles?.header}>
        <span className={styles.title}>{title}</span>
        {extra}
      </div>
      <div
        style={externalStyles?.body}
        className={cx(styles.body, {
          [styles.bordered]: bordered
        })}
      >
        {children}
      </div>
    </div>
  )
}
